import { render, staticRenderFns } from "./DialogEditClient.vue?vue&type=template&id=045e87c1&scoped=true&"
import script from "./DialogEditClient.vue?vue&type=script&lang=js&"
export * from "./DialogEditClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045e87c1",
  null
  
)

export default component.exports